module.exports = "/build/web/svg/practice-match-blue.a9881000782920bfcfd9c2b68058e835.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/practice-match-blue.svg
// module id = 179
// module chunks = 24